import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createEcommerceTag = (_, payload) => {
  return Api(endPoints.ecommerceTags, payload, requestType.POST);
};

const updateEcommerceTag = (id, payload) => {
  return Api(`${endPoints.ecommerceTags}/${id}`, payload, requestType.PUT);
};

const getAllEcommerceTags = (params) => {
  const queryParams = new URLSearchParams();
  if (params.name) queryParams.append("name", params.name);
  if (params.status) queryParams.append("status", params.status);
  if (params.solutionType) queryParams.append("solutionType", params.solutionType);
  if (params.appliesTo) queryParams.append("appliesTo", params.appliesTo);

  const finalUrl = queryParams.toString()
    ? `${endPoints.ecommerceTags}?${queryParams.toString()}`
    : endPoints.ecommerceTags;

  return Api(finalUrl, null, requestType.GET);
};

const getEcommerceTagById = (id) => {
  return Api(`${endPoints.getEcommerceTagById}/${id}`, null, requestType.GET);
};

const getEcommerceTagBySlug = (slug) => {
  return Api(
    `${endPoints.getEcommerceTagBySlug}/${slug}`,
    null,
    requestType.GET,
  );
};

const deleteEcommerceTag = (id) => {
  return Api(`${endPoints.ecommerceTags}/${id}`, null, requestType.DELETE);
};

export {
  createEcommerceTag,
  updateEcommerceTag,
  getAllEcommerceTags,
  getEcommerceTagById,
  getEcommerceTagBySlug,
  deleteEcommerceTag,
};
